const DEFAULT_API_BASE_URL = "http://localhost:8001/api/v1";

const trimTrailingSlash = (value: string): string => value.replace(/\/+$/, "");

export const API_BASE_URL = trimTrailingSlash(
  process.env.REACT_APP_API_URL || DEFAULT_API_BASE_URL,
);

export const API_PATH = (process.env.REACT_APP_API_PATH || "api/v1").replace(
  /^\/+/,
  "",
);

export const API_ORIGIN = (() => {
  try {
    return new URL(API_BASE_URL).origin;
  } catch {
    return "http://localhost:8001";
  }
})();

export const WS_BASE_URL = (() => {
  if (process.env.REACT_APP_WS_URL) {
    return trimTrailingSlash(process.env.REACT_APP_WS_URL);
  }
  const protocol = API_ORIGIN.startsWith("https") ? "wss" : "ws";
  return `${protocol}://${new URL(API_ORIGIN).host}/${API_PATH}/ws`;
})();

